function fetchApplications(onSuccess, onFail) {
    fetch('/revisionhistory/api/applications')
        .then(response => response.json())
        .then(data => onSuccess(data))
        .catch(error => onFail(error));
        
}

function fetchVersions(applicationId, onSuccess, onFail) {
    fetch(`/revisionhistory/api/applications/${applicationId}/versions`)
        .then(response => response.json())
        .then(data => onSuccess(data))
        .catch(error => onFail(error));
}

export { fetchApplications, fetchVersions };